<template>
  <main class="login">
    <section class="login__modal" v-if="!showSuccess">
      <h2 class="login__title">{{ L.localize('Account_Breadcrumb_ForgotPassword') }}</h2>

      <form class="form js-form" data-form="login" @keydown.enter.prevent="send" @keyup.enter="send" v-if="!showSuccess">

        <span class="form__validation" v-if="error">
          {{ error }}
        </span>

        <TextBox
            label="Label_Password"
            v-model="model.password"
            :validate="$v.model"
            @input="$v.model.password.$touch"
            modelPath="password"
            acc="password"
            type="password"
          />

          <TextBox
            label="Label_ConfirmPassword"
            v-model="model.confirmPassword"
            :validate="$v.model"
            @input="$v.model.confirmPassword.$touch"
            modelPath="confirmPassword"
            acc="confirmPassword"
            type="password"
          />

        <Btn :isLoading="loading" @click="send" label="Account_Breadcrumb_ResetPassword" />

      </form>
    </section>
     <div class="login__modal" v-else>
        <span class="form__success">
          {{ L.localize("Account_ResetPassword_Text") }}
        </span>

        <Btn @click="gotoLogin" label="Login_LoginButton" />
      </div>
  </main>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { TextBox, Btn, CheckBox } from 'components/layout/forms'
  import L from 'services/Localization'
  import { Validation } from 'components/helpers'
  import { required, sameAs } from 'vuelidate/lib/validators'

  export default {
    name: 'ResetPassword',
    components: { Validation, TextBox, Btn, CheckBox },
    data() {
      return {
        loading: false,
        error: '',
        L: L,
        showSuccess: false,
        model: {
          password: '',
          confirmPassword: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        validation: 'getValidation'
      }),
      resetCode() {
        return this.$route.query.code
      },
      userId() {
        return this.$route.query.userId
      }
    },
    validations: {
      model: {
        password: { required },
        confirmPassword: {
          required,
          sameAs: sameAs('password')
        }
      }
    },
    methods: {
      send: function() {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }
        let self = this
        this.loading = true
        let payload = {
          userId: this.userId,
          resetCode: this.resetCode,
          password: this.model.password
        }

        this.$store.dispatch('resetPassword', payload).then(
          () => {
            self.showSuccess = true
            self.loading = false
          },
          (response) => {
            self.error = L.localize(response)
            self.loading = false
          }
        )
      },
      gotoLogin: function() {
        this.$router.push({name: 'login'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?12941d54